module.exports = __webpack_public_path__ + "img/Rectangle 70.4b651dc8.svg";